import { Spinner } from '@iwoca/orion';

import { CheckoutLinkDebitCard } from './CheckoutLinkDebitCard/CheckoutLinkDebitCard';
import { StripeLinkDebitCard } from './StripeLinkDebitCard/StripeLinkDebitCard';
import { usePaymentProcessor } from './usePaymentProcessor';
import FallbackErrorModal from '../modals/fallbackErrorModal/FallbackErrorModal';

type LinkDebitCardFormProps = {
    useSectionGridLayout?: boolean;
    stripeShowDefaultPaymentMethodCheckbox?: boolean;
};

export const LinkDebitCardForm = ({
    useSectionGridLayout = true,
    stripeShowDefaultPaymentMethodCheckbox = false
}: LinkDebitCardFormProps) => {
    const { paymentProcessor, isLoading, isError } = usePaymentProcessor();

    if (isLoading) return <Spinner />;

    if (isError) return <FallbackErrorModal />;

    if (paymentProcessor === 'Checkout') {
        return (
            <CheckoutLinkDebitCard
                useSectionGridLayout={useSectionGridLayout}
            />
        );
    }

    return (
        <StripeLinkDebitCard
            showDefaultPaymentMethodCheckbox={
                stripeShowDefaultPaymentMethodCheckbox
            }
            useSectionGridLayout={useSectionGridLayout}
        />
    );
};
